import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Box, Chip, Stack, TableCell, Typography } from "@mui/material"
import { COLOR_FROM_CLASSIFICATION } from "library/SFG20/constants.mjs"
import { formatTimeShort } from "lib/format-time"
import { useBoundValue } from "lib/@components/binding/use-bound-value"

export function WeekPlanEntry({ item: week }) {
    const { days, schedule } = useBoundContext()
    const day = days[week]
    const daySchedule = day?.scheduleIndex[schedule]
    const [showAssets] = useBoundValue("showAssets", false)
    const [showVisit] = useBoundValue("showVisit", true)
    const [showTime] = useBoundValue("showTime", false)

    if (!daySchedule) return <TableCell />
    const { tasks } = daySchedule
    const numberOfAssets = Math.max(1, tasks.map((c) => c.assetIndex.toString()).unique().length)

    const allTasks = daySchedule.amber + daySchedule.green + daySchedule.pink + daySchedule.red

    return (
        <TableCell sx={{ position: "relative", p: 0 }} align="center">
            <Box
                position="absolute"
                display="flex"
                flexDirection="row"
                left={1}
                right={1}
                top={1}
                bottom={1}
                sx={{ opacity: showVisit || showTime || showAssets ? 0.2 : 1 }}
            >
                <Box width={daySchedule.red / allTasks} bgcolor={COLOR_FROM_CLASSIFICATION.Red} />
                <Box width={daySchedule.pink / allTasks} bgcolor={COLOR_FROM_CLASSIFICATION.Pink} />
                <Box width={daySchedule.amber / allTasks} bgcolor={COLOR_FROM_CLASSIFICATION.Amber} />
                <Box width={daySchedule.green / allTasks} bgcolor={COLOR_FROM_CLASSIFICATION.Green} />
            </Box>
            <Box position="absolute" display="flex" flexDirection="row" left={1} right={1} top={1} height={5}>
                <Box width={daySchedule.red / allTasks} bgcolor={COLOR_FROM_CLASSIFICATION.Red} />
                <Box width={daySchedule.pink / allTasks} bgcolor={COLOR_FROM_CLASSIFICATION.Pink} />
                <Box width={daySchedule.amber / allTasks} bgcolor={COLOR_FROM_CLASSIFICATION.Amber} />
                <Box width={daySchedule.green / allTasks} bgcolor={COLOR_FROM_CLASSIFICATION.Green} />
            </Box>

            <Stack
                sx={{ position: "relative", m: "auto", zIndex: 1, width: 1, px: 0.5, pt: showAssets ? 0.5 : 0 }}
                direction="row"
                spacing={0.5}
                alignItems="center"
                justifyContent="center"
            >
                {!!showAssets && (
                    <Box lineHeight={0}>
                        <Chip
                            sx={{
                                "& .MuiChip-label": {
                                    px: 1,
                                    overflow: "visible",
                                },
                                height: 20,
                                overflow: "visible",
                            }}
                            size="small"
                            label={numberOfAssets}
                        />
                    </Box>
                )}
                {showVisit ? (
                    <Box flex={1} lineHeight={0} sx={{ whiteSpace: "nowrap" }}>
                        <Typography color="text.secondary" variant="caption">
                            {daySchedule.visits.map("label").join(" ")}
                        </Typography>
                    </Box>
                ) : null}
                {showTime ? (
                    <Box lineHeight={0} flex={1} textAlign="right">
                        <Typography
                            sx={{
                                height: 20,
                                fontWeight: "bold",
                            }}
                            variant="caption"
                        >
                            {formatTimeShort(daySchedule.minutes)}
                        </Typography>
                    </Box>
                ) : null}
            </Stack>
        </TableCell>
    )
}
